import { IUpdateDisciplinaItemsChecklistUseCase } from "../../../presentation/useCases/update/update_disciplina_items_checklist_use_case";
import { UpdateDisciplinaChecklistRequestModel, UpdateDisciplinaChecklistResponseModel } from "../../models/disciplina_item_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class UpdateDisciplinaItemsChecklistUseCase implements IUpdateDisciplinaItemsChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async updateDisciplinaItemsChecklist(model: UpdateDisciplinaChecklistRequestModel): Promise<UpdateDisciplinaChecklistResponseModel> {
    return await this.repository.updateDisciplinaChecklist(model);
  }
}
